import create from 'zustand';
import { ApiResponse } from '../../model/common/apiResponse';
import { axiosService, ServiceEndPoint } from '../../Services/common/Axios.service';
const service_endpoint = ServiceEndPoint.account_service;
export interface userAccess {
    id: number;
    username: string;
    name: string;
    email: string;
    is_spherewms_admin: boolean;
}

interface UserStore {
    currentUser: userAccess | null;
    setCurrentUser:(userAccess:any) => any;
    getCurrentUser: () => Promise<userAccess | null>;
    fetchUser: () => Promise<userAccess | null>;    
    loading: boolean;
    error: string | null;
    reset: () => void;
}

interface WhoAmIResponse {
    user: {
        id: number;
        username: string;
        name: string;
        email: string;
        is_spherewms_admin: boolean;
    };
}

const useUserStore = create<UserStore>((set, get) => ({
    currentUser: null,
    loading: false,
    error: null,
    fetchUser: async () => {
        // const state = get(); 
        // if (state?.currentUser) return state.currentUser;
        try {
            const response = await axiosService.post(`${service_endpoint}whoami`,{}) as ApiResponse<WhoAmIResponse>;
            const userData = response.data?.user;
            if (userData) {
                const user: userAccess = {
                    id: userData.id,
                    username: userData.username,
                    name: userData.name,
                    email: userData.email,
                    is_spherewms_admin: userData.is_spherewms_admin
                };
                set({ currentUser: user, loading: false, error: null });
                return user;
            }
            return null;
        } catch (error:any) {
            set({ loading: false, error: error.message });
            return null;
        } finally {
           
        }
    },
    setCurrentUser: (user: userAccess) => {
        set({ currentUser: user });
    },
    getCurrentUser: async () => {
        return get().currentUser;
    },
    reset: () => {
        set({ currentUser: null, loading: false, error: null });
    }
}));
{}
export default useUserStore;